export const editMobile = {
  mobile: {
    props: {},
  },
}
